import { atom } from "recoil";

interface ToastState {
  writeSuccess: boolean;
  patchSuccess: boolean;
  deleteSuccess: boolean;
  restoreSuccess: boolean;
  generalSuccess: boolean;
  generalDeleteSuccess: boolean;
  multipleDeviceSuccess: boolean;
  copySuccess: boolean;
}

export const toastState = atom<ToastState>({
  key: "toastState",
  default: {
    writeSuccess: false,
    patchSuccess: false,
    deleteSuccess: false,
    restoreSuccess: false,
    generalSuccess: false,
    generalDeleteSuccess: false,
    multipleDeviceSuccess: false,
    copySuccess: false,
  },
});
